/* eslint-disable import/no-unresolved */
import React from 'react';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import ScoresConfig from 'src/components/leads/scoresConfig/ScoresConfig';
import { Backdrop, CircularProgress } from '@material-ui/core';
import { useStyles } from './styles';

const ScoreConfigPage = (props) => {
  const {
    scores,
    onSubmitScore,
    onChangeScores,
    onSubmitProcess,
    loading,
  } = props;
  const classes = useStyles();

  return (
    <>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress />
      </Backdrop>
      <CardTitle title="Configuración de cálculos score - Victory +" />

      <ScoresConfig
        scores={scores}
        onSubmitScore={onSubmitScore}
        onChangeScores={onChangeScores}
        onSubmitProcess={onSubmitProcess}
      />
    </>
  );
};

export default ScoreConfigPage;
